<template>
    <div class="third todetailPageData">
        <div class="third-formOne">
            <div class="formOne-btn">
                <div class="btn-left">
                    <span class="left-back-icon" @click="changeComponent">
                        <i class="el-icon-arrow-left"></i>
                        <span class="left-back-title">返回</span>
                    </span>
                    <span class="left-back-shu">
                        <span class="left-back-shu-content"></span>
                    </span>
                    <span class="left-back-content">详情</span>
                </div>
            </div>
            <div class="third-one library">
                <div class="formOne-forms">
                    <el-form :inline="false" ref="faqForm" label-width="100px" style="border-bottom: 1px solid #ebeef5;">
                        <div class="forms-one" style="margin-top: 57px;">
                            <div class="one-title">
                                <div class="title-left">
                                    <span class="left-icon">
                                        <i class="el-icon-s-operation"></i>
                                    </span>
                                    <span class="left-content">反馈信息</span>
                                </div>
                            </div>
                            <div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="建议内容：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.question }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="使用平台：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.useType }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="使用设备：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.useDevice }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="品牌型号：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.deviceType }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="软件版本：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.deviceVersion }}</span>
                                       </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="建议时间：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.createTime }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list">
                                    <div class="list-one-line">
                                        <el-form-item label="图片：">
                                          <template v-if="imglist.length">
                                            <el-image
                                             class="imgClass" v-for="item in imglist" :key="item.index" :src="item" alt=""
                                                :preview-src-list="imglist" :z-index="item.index">
                                            </el-image>
                                          </template>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                    <el-form :inline="true" ref="faqForm2" label-width="100px">
                        <div class="forms-one">
                            <div class="one-title">
                                <div class="title-left">
                                    <span class="left-icon">
                                        <i class="el-icon-s-operation"></i>
                                    </span>
                                    <span class="left-content">用户信息</span>
                                </div>
                            </div>
                            <div>
                                <div class="one-list" style="display: inline-block;vertical-align: top;margin-right:100px;">
                                    <div class="list-one-line">
                                        <el-form-item label="建议人账号：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.keyId }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list" style="display: inline-block;vertical-align: top;margin-right:100px;">
                                    <div class="list-one-line">
                                        <el-form-item label="建议人姓名：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.userName }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="one-list" style="display: inline-block;vertical-align: top;margin-right:100px;">
                                    <div class="list-one-line">
                                        <el-form-item label="建议人角色：">
                                            <span style="font-size: 12px; color: #828D9A;">{{ todetailPageData.userRoles }}</span>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { removeStore, getStore } from "@/utils/store";
import { mapActions, mapState, mapMutations } from "vuex";
import { cloneDeep } from "lodash";
export default {
    name: "funcSuggestionDetail",
    props: {
        enterData: Object
    },
    data() {
        return {
            todetailPageData: '',
            imglist: [],
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
            componentsName: state => state.robotsManage.robotsManage_funcSuggestion_ComponentName,
        })
    },
    created() {
        this.todetailPageData = this.enterData
        if (this.todetailPageData.images) {
          this.imglist = this.todetailPageData.images.split(',')
        }
        console.log(this.imglist);
        console.log(this.todetailPageData);
    },
    methods: {
        ...mapMutations({
            changeComponentName: 'SET_robotsManage_funcSuggestion_ComponentName',
        }),
        // 改变index页面的component的值
        changeComponent() {
            this.changeComponentName("BasicPage");
        },
    }
};
</script>

<style lang="scss">
.todetailPageData {
    min-height: 100vh;
    .third-formOne {
        height: 100vh;
    }
    .el-table__body-wrapper {
        height: calc(100vh - 210px) !important;
    }
    .el-form-item__label {
        padding-right: 10px;
    }
    .el-input-number.is-without-controls .el-input__inner {
        text-align: left;
    }
    .imgClass {
        width: 100px;
        height: 100px;
        // cursor: pointer;
        margin: 0 10px 10px 0;
    }
    // .el-form {
    //     border-bottom: 1px solid #ebeef5;
    // }
}
</style>
